export const validatePassword = (password: string = ''): string | null =>
  password.length >= 6 ? null : 'Password is invalid';
